import { Button, Center, Flex, Heading, Link, Text } from "@chakra-ui/react";
import { BsCart4 } from "react-icons/bs";
import { FiHome } from "react-icons/fi";
import { useNavigate } from "react-router";

export const PayFailure = () => {
  const navigate = useNavigate();
  return (
    <>
      <>
        <Center display={"flex"} flexDirection="column" textAlign={"center"}>
          <Heading mb={3} as="h4">
            Su pago quedó pendiente.&#128542;
          </Heading>
          <Text>
            Nuestros administradores volverán a analizar el pago y cuando se
            resuelva se te informará en la seccion de{" "}
            <Link href="/buys" textDecoration={"underline"}>
              Mis Compras
            </Link>
          </Text>
          <Flex flexDirection={{ base: "column", sm: "row" }} mt={3}>
            <Button
              mb={{ base: "10px", sm: "0px" }}
              mr={{ base: "0px", sm: "10px" }}
              leftIcon={<FiHome />}
              onClick={() => {
                navigate("/");
              }}
            >
              Ir al inicio
            </Button>
            <Button
              leftIcon={<BsCart4 />}
              onClick={() => {
                navigate("/cart");
              }}
            >
              Ir a ver tu carrito
            </Button>
          </Flex>
        </Center>
      </>
    </>
  );
};
